import {
  DlpExpressionsModalNameEnum,
  DlpExpressionsModalState,
} from '../../type';
import { DeleteModal } from './delete';
import { EditOrAddModal } from './editOrAdd';
import { ImportModal } from './import';

export const ExpressionsModal = ({
  modalState,
  onClose,
  refreshTable,
}: {
  modalState: DlpExpressionsModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  if (modalState.name === DlpExpressionsModalNameEnum.Delete) {
    return (
      <DeleteModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }

  if (
    modalState.name === DlpExpressionsModalNameEnum.Add ||
    modalState.name === DlpExpressionsModalNameEnum.Edit
  ) {
    return (
      <EditOrAddModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }

  if (modalState.name === DlpExpressionsModalNameEnum.Import) {
    return (
      <ImportModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }
  return <></>;
};
